export enum BrowseScope {Devices, Samples, Soundfonts}